import { FC } from 'react'
import { PrefectureAndCity, PrefectureAndCityProps } from './PrefectureAndCity'
import { ScoreWithLink, ScoreWithLinkProps } from './Score'
import { PurchasePrice, PurchasePriceProps } from './PurchasePrice'
import { CemeteryNameWithLink } from './CemeteryName'

export interface OutlinesProps {
  cemeteryId: number
  area?: PrefectureAndCityProps
  name?: string
  review?: Omit<ScoreWithLinkProps, 'cemeteryId'>
  purchasePrice?: PurchasePriceProps
}

export const Outlines: FC<OutlinesProps> = (props) => {
  const { cemeteryId, name, area, review, purchasePrice } = props
  return (
    <>
      {area && (
        <PrefectureAndCity prefecture={area.prefecture} city={area.city} />
      )}
      {name && <CemeteryNameWithLink cemeteryId={cemeteryId} name={name} />}
      {review && (
        <ScoreWithLink
          cemeteryId={cemeteryId}
          score={review.score}
          count={review.count}
        />
      )}
      {purchasePrice && <PurchasePrice {...purchasePrice} />}
    </>
  )
}
